// import React, {Component} from 'react';
import {
  View,
  Text
} from 'react-native';

import ff from './ff';
import bf from './bf';
import ic from './ic';
import cf from './cf';
import ce from './ce';
import cr from './cr';

import c30v1a from './c30v1a'; // 団体情報
import i10v1a from './i10v1a'; // 設備情報
import i11v1a from './i11v1a'; // 時間帯情報
import i14v1a from './i14v1a'; // 設定情報

import c51v1a from './c51v1a';

import cView from './cView';

import i1zv from './i1zv_20211024';

const _getDates = (p_sttDate) => {
  let _sttDate = p_sttDate;
  let _endDate = '';
  const _day = String(_sttDate).substr(8,10);
  if (ic.g_dvcMode == 's') { // スマホの場合
//ff.l('i1zv4 40: {}'.f(_day))
    if ( _day == '01') { // 上旬
      _sttDate = ff.myDT_cnv('fdm', _sttDate);
      _endDate = ff.myDT_add('day', _sttDate, 9);
    }
//    else if ( _day == '10') { // 中旬
    else if ( _day == '11') { // 中旬
//      _sttDate = ff.myDT_cnv('fdm', _sttDate);
//      _endDate = ff.myDT_add('day', _sttDate, 9);
      _sttDate = ff.myDT_add('day', ff.myDT_cnv('fdm', _sttDate), 10);
      _endDate = ff.myDT_add('day', _sttDate, 9);
    }
    else { // 下旬
      _sttDate = ff.myDT_add('day', ff.myDT_cnv('fdm', _sttDate), 20);
      _endDate = ff.myDT_cnv('ldm', _sttDate);
    }
  }
  else { // スマホ以外の場合
    _sttDate = ff.myDT_cnv('fdm', _sttDate);
    _endDate = ff.myDT_cnv('ldm', _sttDate);
  };  
//ff.l('i1zv4 64: "{}", {}, {}'.f(_day, _sttDate, _endDate));
  return { sttDate: _sttDate, endDate: _endDate};
};

export default class i1zv4 extends i1zv { // 設備予約　管理用用画面

constructor(props) { // state の宣言だけでは駄目な模様
  super(props);
  this.state = cf.myRN_crt_stss(
    this.$cd_stss,
    this.$id_stss
  );
}

$id_stss = { //  子で上書き
  s_i1zri21d: ff.myDT_getDate('today'),
  s_id: null,
//  s_i1zri21d: null,
};

_l_i10rt11is = [200]; // 室・設備の種別

$clp_loadLists = () => [ // 親を上書き
  global.t?._op_loadList(),
];

_op_loadList = () => new Promise( async _o_end1 => {

  let _id = cf.myNV_getId();
  if (_id) await cf.myRN_setStt({
    s_i1zri21d: `${_id}-01`,
    s_id: _id
  })

/*
  let _sttDate = null;
  let _endDate = null;
  if (ic.g_dvcMode == 's') { // スマホの場合
    _sttDate = global.t?.state.s_i1zri21d;
    if ( String(_sttDate).substr(8,10) == '01') { // 前半
      _sttDate = ff.myDT_cnv('fdm', _sttDate);
      _endDate = ff.myDT_add('day', _sttDate, 14);
    }
    else { // 後半
      _sttDate = ff.myDT_add('day', ff.myDT_cnv('fdm', _sttDate), 15);
      _endDate = ff.myDT_cnv('ldm', _sttDate);
    }
  }
  else { // スマホ以外の場合
    _sttDate = ff.myDT_cnv('fdm', global.t?.state.s_i1zri21d);
    _endDate = ff.myDT_cnv('ldm', _sttDate);
  };
*/
  const _d_dates = _getDates(global.t?.state.s_i1zri21d);
  const _sttDate = _d_dates.sttDate;
  const _endDate = _d_dates.endDate;
//ff.l('i1zv4 56: {}, {}'.f(_sttDate, _endDate));
  i1zv.op_updHdys({
    sttDate: _sttDate,
    endDate: _endDate,
  })
  .then(async () => {
//    for await (let [_idx, _i10rt11i] of ff.e(global.t?._l_i10rt11is)) {
    for await (let [_idx, _i10rt11i] of ff.e(global.t?._l_i10rt11is)) {
      let _state = `sdld_i10rListsss${_i10rt11i}`;
      await i10v1a.op_loadList({
        elm: 'i10r',
        state: _state,
        o_cnd: _dd_datss => {
          let _cnd = cf.c('i10r', `i10rt11i = ${_i10rt11i}`)
          return _cnd;
        },
        dd_cldDefss: {
          i110: {
            elm: 'i110',
            o_cnd: _dd_datss => {
              let _cnd = cf.c('i110', `i110b51k = (SELECT _key FROM t_i11r WHERE ${cf.c('i11r', `t_i11r._fst = ${_dd_datss.i10r.d_flds.i10rb51f}`)})`) // 指定した利用日に紐づく予約情報
              return _cnd;
            },
            dd_cldDefss: {
/*
              i1zr: {
                elm: 'i1zr',
                o_cnd: _dd_datss => {
                  let _cnd = cf.c('i1zr', `i1zrb41f = ${_dd_datss.i10r.d_flds._fst} AND i1zri21d >= "${_sttDate}" AND i1zri21d <= "${_endDate}" AND i1zrs11i IN (70, 80, 90)`) // 指定した利用日に紐づく予約情報
                  return _cnd;
                },
                dd_cldDefss: {
                  i1z0: {
                    elm: 'i1z0',
                    o_cnd: _dd_datss => {
                      let _cnd = cf.c('i1z0', `i1z0b61k = ${_dd_datss.i1zr.d_flds._key}`, false, false) // 指定した利用日に紐づく予約情報
                      return _cnd;
                    },
                    dd_rfrss: {
                      i110: {
                        elm: 'i110',
                        o_cnd: _d_flds => {
                          let _cnd = cf.c('i110', `_fst = ${_d_flds.i1z0b51f}`);
                          return _cnd;
                        },
                      },
                    },
                  },
                },
              },
*/
              i1z3: {
                elm: 'i1z3',
                o_cnd: _dd_datss => {
                  let _cnd = cf.c('i1z3', `i1z3b41f = ${_dd_datss.i10r.d_flds._fst} AND i1z3i21d >= "${_sttDate}" AND i1z3i21d <= "${_endDate}"`, false, false) // 指定した利用日に紐づく予約情報
//ff.l('i1zv4 110: {}'.f(_cnd))
                  return _cnd;
                },
/*
                dd_rfrss: {
                  i110: {
                    elm: 'i110',
                    o_cnd: _d_flds => {
                      let _cnd = cf.c('i110', `_fst = ${_d_flds.i1z3b51f}`);
                      return _cnd;
                    },
                  },
                },
*/
              },
            },
          },
        },
        op_atrAll: () => new Promise( _o_end2 => { 
          if (global.t?.state[_state]) {
            global.t?.setState({
              [_state]: bf.p(global.t?.state[_state], _next => {
                _next.i10r.map( (_d_i10rs, _idxI10r) => {
                  _d_i10rs.d_tbls = { pfx: _d_i10rs.d_flds.i10rc31s, d_is: {} };
                  _d_i10rs.dld_cldDatsss.i110.map( (_d_i110s, _i110Idx) => { // ctg
                    _d_i110s.d_tbls = { pfx: _d_i110s.d_flds.i110c31s, d_is: {} };
/*
                    _d_i110s.dld_cldDatsss.i1zr.map( (_d_i1zrs, _i1zrIdx) => { // ctg
                      let _cmn = _d_i1zrs.d_flds.i1zri21d;
                      _d_i1zrs.dld_cldDatsss?.i1z0.map( (_d_i1z0s, _i1z0Idx) => {
                        if ( _d_i1z0s.d_flds.i1z0b51f == _d_i110s.d_flds._fst) {
                          _d_i110s.d_tbls.d_is[_cmn] = { pfx:'×' };
                        };
                      });
                    });
*/
                    _d_i110s.dld_cldDatsss.i1z3.map( (_d_i1z3s, _i1z3Idx) => { // ctg
                      let _cmn = _d_i1z3s.d_flds.i1z3i21d;
//ff.l('i1zv4 145: {}'.f(_cmn))
                      if ( _d_i1z3s.d_flds.i1z3b51f == _d_i110s.d_flds._fst) {
                        if ( _d_i1z3s.d_flds.i1z3i31i > 0) {
                          _d_i110s.d_tbls.d_is[_cmn] = { pfx:'×' };
                        };
                      };
                    });
                  })
                })
              }),
            }, () => {
              _o_end2();
            });
          }
          else {
            _o_end2();
          }
        }),
      })
    };
    _o_end1();
  })

});

// $opb_chk, render は個別に実装

render() {

  let _r = [];

//  let _id = cf.myNV_getId();

//  let _sttDate = ff.myDT_cnv('fdm', global.t?.state.s_i1zri21d);
//  let _endDate = ff.myDT_cnv('ldm', _sttDate);
  const _d_dates = _getDates(global.t?.state.s_i1zri21d);
  const _sttDate = _d_dates?.sttDate;
  const _endDate = _d_dates?.endDate;

  let _l_cmns = ff.myDT_cnv('dates', { stt:_sttDate, end: _endDate });

  let _minDate = ff.myDT_cnv('fdm', ff.myDT_getDate('today'));
  let _maxDate = ff.myDT_cnv('ldm', ff.myDT_add('mth', _minDate, 6));
  let _prevDate = ff.myDT_add('mth', global.t?.state.s_i1zri21d, -1);
  let _nextDate = ff.myDT_add('mth', global.t?.state.s_i1zri21d, +1);

  global.t?._l_i10rt11is.map( _i10rt11i => {

    let _state = `sdld_i10rListsss${_i10rt11i}`;
    let _n_lblW = ic.s(2 * 4);
    let _n_cnt = ff.myCM_getLen(_l_cmns);
    let _n_w1 = (ic.gn_bdyW - _n_lblW) / _n_cnt;

    _r.push(
      ce.c(ce.Tbl2, {
        key: `Tbl.${_i10rt11i}`,
        b_vsb: true,
        b_ctg: true,
        b_tgt: true,
        state: _state,
        l_cmns: _l_cmns,
        o_pfx: _cmn => ff.myDT_cnv('day', _cmn),
        o_sfx: _cmn => {
          let _sfx = '休';
          if (ff.i(_cmn, global.t?.state.sl_hdys ?? []) == false) {
            _sfx = ff.myDT_cnv('dow', _cmn);
          }
          return _sfx;
        }, 
        n_hdrRpt: 
          ic.g_dvcMode == 's' ?
          2
          :
          null
        ,
        d_tops: {
          pfx:  ff.myDT_cnv('西暦月', global.t?.state.s_i1zri21d),
          d_stls: {
            fontSize: ic.s(1.4),
          },
          o_pvs:
          (ff.i(global.t?.d_viewDefs.class, ['cdr', 'i1zv4a'])) ?
            null
          : (!global.t?.state.s_id && _prevDate >= _minDate) ?
            () => {
              cf.s()
              .then(() => {
                cf.myRN_setStt({
                  s_i1zri21d: _prevDate
                })
                .then(() => {
                  global.t?._op_loadList()
                  .then(()=>{
                    cf.h();
                  });
                })
              })
            }
          : null,
          o_next:
          (ff.i(global.t?.d_viewDefs.class, ['cdr', 'i1zv4a'])) ?
            null
          : (!global.t?.state.s_id && _nextDate <= _maxDate) ? 
            () => {
              cf.s()
              .then(() => {
                cf.myRN_setStt({
                  s_i1zri21d: _nextDate
                })
                .then(() => {
                  global.t?._op_loadList()
                  .then(()=>{
                    cf.h();
                  });
                })
              })
            }
          :null,
        },
        od_stlHdrPfxs: () => {
          let _d = 
            {
              color: 'red',
              fontWeight: 'bold',
              width: _n_lblW,
              backgroundColor: ic.o_getCcd('h'),
              paddingLeft: ic.m(1),
              paddingRight: ic.m(1),
            };
          return _d;
          
        },
        od_stlLbls: () => {
          let _d = 
            {
              width: _n_lblW,
              backgroundColor: ic.o_getCcd('h'),
              paddingLeft: ic.m(1),
              paddingRight: ic.m(1),
            };
          return _d;
          
        },
        od_stlCells: (_cmn) => {          
          let _d = {
            flex: _n_w1,
            backgroundColor: 
              (ff.i(_cmn, global.t?.state.sl_hdys ?? [])) ?
                ic.g_ccdHN 
            : (ff.myDT_cnv('day', _cmn) % 2 == 0) ? 
                ic.o_getCcd('h') 
              : ic.g_ccdWN,
          };
          return _d;
        },
        od_stlCellPfxs: _cmn => { // 日付
          const _d = 
            ic.g_dvcMode == 's' ?
            {
              fontSize: ic.s(0.9),
            }
            :
            {
              fontWeight: 'bold',
            };
          return _d;
        },
        od_stlLblPfxs: () => (
          ic.g_dvcMode == 's' ?
          null
          :
          {
            fontWeight: 'bold',
          }
        ),
        od_stlDataPfxs: () => (
          ic.g_dvcMode == 's' ?
            {
              fontSize: ic.s(1.2),
            }
          :
            {
              fontWeight: 'bold',
              fontSize: ic.s(1.2),
            }
        ),
        od_stlCtgRows: () => {          
          let _d = {
            minHeight: ic.s(2),
          };
          return _d;
        },
        od_stlDtlRows: () => {          
          let _d = {
              minHeight: ic.s(2),
          };
          return _d;
        },
      })
    );
  });

  let _ld_iss = [];
  if (ic.g_dvcMode == 's') { // スマホ
    ff.myCM_getRng(12).map( _n => {
  //                            const _mth = String(ff.myDT_add('mth', ff.myDT_cnv('fdm', ff.myDT_getDate('today')), _n -1)).substr(0,7);
  //                            return { key: _mth, pfx: _mth };
      const _key1 = ff.myDT_add('mth', ff.myDT_cnv('fdm', ff.myDT_getDate('today')), _n - 1);
      const _pfx1 = String(_key1).substr(0,7) + ' 上旬';
      _ld_iss.push({ key: _key1, pfx: _pfx1 });
      const _key2 = ff.myDT_add('day', _key1, 10);
      const _pfx2 = String(_key2).substr(0,7) + ' 中旬';
      _ld_iss.push({ key: _key2, pfx: _pfx2 });
      const _key3 = ff.myDT_add('day', _key1, 20);
      const _pfx3 = String(_key3).substr(0,7) + ' 下旬';
      _ld_iss.push({ key: _key3, pfx: _pfx3 });
    });
  }
  else { // スマホ以外
    ff.myCM_getRng(12).map( _n => {
  //                            const _mth = String(ff.myDT_add('mth', ff.myDT_cnv('fdm', ff.myDT_getDate('today')), _n -1)).substr(0,7);
  //                            return { key: _mth, pfx: _mth };
      const _key = ff.myDT_add('mth', ff.myDT_cnv('fdm', ff.myDT_getDate('today')), _n - 1);
      const _pfx = String(_key).substr(0,7);
      _ld_iss.push({ key: _key, pfx: _pfx });
    });
  };

  return (
    ce.c(ce.RootDtl, 
      /* ----------------------------------------------------------------------------------------------------
      スタッフ用 利用状況
      ---------------------------------------------------------------------------------------------------- */
      {
        key: -1,
        d_hdrs: {
          pfx: '予約状況カレンダー',
        },
        d_bdys: {
          l_clds: [

            // list ---------------------------------------------------------------------------------------------------
            ce.c(ce.Pnl, {
              key: -1,
              mode: 'list',
              b_vsb: global.t?.state.sgc_pnlMode == 'list' ? true : false,
              d_hdrs: 
//                (ff.i(global.t?.d_viewDefs.class == 'i1zv4a')) ?
                (ff.i(global.t?.d_viewDefs.class, ['cdr', 'i1zv4a'])) ?
                  {
                    d_ctrs: {
                      l_clds: [
                        ce.c(ce.Pck, { // 予約状況
                          key: -10, 
                          pfx: '対象月',
                          b_vsb: true,
                          b_edit: true,
                          b_row: true,
                          b_rvs: true,
                          state: 's_mth',
                          n_col: 9,
                          d_stlCtas: {
                            marginLeft: ic.m(1),
                          },
/*
                          ld_iss: ff.myCM_getRng(12).map( _n => {
//                            const _mth = String(ff.myDT_add('mth', ff.myDT_cnv('fdm', ff.myDT_getDate('today')), _n -1)).substr(0,7);
//                            return { key: _mth, pfx: _mth };
                            const _key = ff.myDT_add('mth', ff.myDT_cnv('fdm', ff.myDT_getDate('today')), _n - 1);
                            const _pfx = String(_key).substr(0,7);
                            return { key: _key, pfx: _pfx };
                          }),
*/
                          ld_iss: _ld_iss,
                          o_onChg: _d_is => {
//                            const _date = `${_d_is.key}-01`;
                            const _sttDate = _d_is.key;
                            cf.s();
                            cf.myRN_setStt({
                              s_i1zri21d: _sttDate,
                            })
                            .then(() => {
                              global.t?._op_loadList()
                              .then(()=>{
                                cf.h();
                              });
                            })
                          },
                        }),
                      ],
                    }
                  }
                : null,
              d_bdys: {
                l_clds: _r,
              },
            }),

          ],
        }
      }
    )
  );
}

}
